<template lang="html">
  <div class="projectBasicContainer">
    <h1 v-if="isAddNewAdmin">新增管理員</h1>
    <h1 v-else>編輯管理員</h1>
    <div class="subtitle"><span>*</span> 為必填</div>
    <div class="tableContainer">
      <div class="fourColumn">
        <div class="title required">姓名</div>
        <Input
        v-model="admin.name"
        class="inputItemStyle"
        type="text" />
        <div class="title required">職位</div>
        <Select class="inputItemStyle" v-model="admin.positionId" style="max-width:300px" size="large" placeholder="請選擇">
          <Option v-for="item in positionOptions" :value="item.id" :key="item.id">{{ item.positionName }}</Option>
        </Select>
        <div class="title required">帳號</div>
        <Input
        v-model="admin.account"
        class="inputItemStyle"
        type="text"/>
        <div class="title required">密碼</div>
        <Input
        v-model="admin.password"
        :disabled="!isAddNewAdmin"
        class="inputItemStyle"
        type="text"/>

      </div>
    </div>
    <div class="btnContainer">
      <div v-if="isAddNewAdmin">
        <Button type="success" @click="submitNewAdmin">儲存</Button>
        <Button to="admin" >取消</Button>
      </div>
      <div v-else>
        <Button type="success" @click="submitEdit">更新</Button>
        <Button @click="backToAdminInfo" >取消</Button>
      </div>
    </div>
  </div>
</template>

<script>
import jsCookie from 'js-cookie'
import API from "../asset/js/API"
export default {
  created() {
    // webServer.defaults.headers.common['x-access-token'] = jsCookie.get('token')
    this.getPositionList()
    const { adminInfo } = this.$route.params;
    if (adminInfo) {
      this.isAddNewAdmin = false;
      this.setData(adminInfo)
    }
  },
  data() {
    return {
      isAddNewAdmin: true,
      required: {
        name: "姓名",
        positionId: "職位",
        account: "帳號"
      },
      admin: {
        id: null,
        name: null,
        positionId: null,
        account: null,
        password: null
      },
      positionOptions: []
    };
  },
  methods: {
    getPositionList() {
      API.get(`/manager/position`)
      .then(res => {
        this.positionOptions = res.result.list
      })
      .catch(err => {
        console.error('職位列表',err)
      })
    },
    submitNewAdmin() {
      API.post(`/manager`, this.admin)
      .then(res => {
        this.$Message.info(res.result)
        this.$router.push("admin");
      })
      .catch(err => {
        console.error('新增管理員',err)
      })
    },
    setData(data) {
      this.admin = {...this.admin, ...data }
    },
    submitEdit() {
      const postData = {
        name: this.admin.name,
        account: this.admin.account,
        positionId: this.admin.positionId
      }
      API.put(`/manager/${this.admin.id}`, postData)
      .then(res => {
        this.$Message.info(res.result)
      })
      .catch(err => {
        console.error('編輯管理員',err)
      })

    },
    backToAdminInfo() {
      this.$router.push({ name: "AdminInfo", params: { ...this.admin } });
    },

  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/base.scss";
@import "@/scss/components.scss";

.subtitle {
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 10px;
  & > span {
    color: red;
  }
}
.inputItemStyle {
  padding: 8px;
}
.inputTime {
  width: 100px;
}
.authorize-box {
  padding: 8px;
  display: flex;
  align-items: center;
}
.required::before {
  content: "* ";
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/EditAdmin.vue